import {
  getSubscriptionsClient,
  makeOptionallyAuthenticatedQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { ActiveServiceDto } from '@b-stock/subscription-api-client'

const getActiveSubscriptions = async (
  accessToken: string | null,
  accountId?: string
): Promise<ActiveServiceDto | null> => {
  if (!accessToken || !accountId) return null

  const subscriptionClient = getSubscriptionsClient()

  const { data } =
    await subscriptionClient.subscriptionsControllerGetActiveService(
      {
        sellerAccountId: accountId,
      },
      buildAxiosRequestConfig({ accessToken })
    )

  return data
}

const activeSubscriptionsQuery = makeOptionallyAuthenticatedQuery(
  'activeSubscriptions',
  getActiveSubscriptions
)

export default activeSubscriptionsQuery
